<app-cd-popup>
  @if (data.title) {
  <cds-popup-title>{{ data.title | lang }}</cds-popup-title>
  }
  <cds-popup-content>
    @if (data.message) {
    <div class="cds-h2-light" innerHtml="{{ data.message | lang : data.params }}"></div>
    } @if (!data.message) {
    <div class="cds-h2-light" innerHtml="{{ 'common.action.success' | lang : data.params }}"></div>
    } @if (data.subMessage) {
    <div innerHtml="{{ data.subMessage | lang }}"></div>
    }
  </cds-popup-content>
  <cds-popup-actions>
    <cds-button size="sm" (click)="gotIt()">{{ 'common.gotIt' | lang }} </cds-button>
  </cds-popup-actions>
</app-cd-popup>
